import constants from "../config/constants";
const locationLbl = {
  CN: {
    [constants.INPUT_ID_REGION_SELLER]: "Province",
    [constants.INPUT_ID_CITY_SELLER]: "Prefecture-level city",
    [constants.INPUT_ID_MUNICIPAL_SELLER]: "Districts, Counties, County-level cities",
    [constants.INPUT_ID_REGION_SHIPMENT_WH]: "Province",
    [constants.INPUT_ID_CITY_SHIPMENT_WH]: "Prefecture-level city",
    [constants.INPUT_ID_MUNICIPAL_SHIPMENT_WH]: "Districts, Counties, County-level cities"
  },
  US: {
    [constants.INPUT_ID_REGION_SELLER]: "State",
    [constants.INPUT_ID_CITY_SELLER]: "County",
    [constants.INPUT_ID_MUNICIPAL_SELLER]: "Towns / Cities",
    [constants.INPUT_ID_REGION_SHIPMENT_WH]: "State",
    [constants.INPUT_ID_CITY_SHIPMENT_WH]: "County",
    [constants.INPUT_ID_MUNICIPAL_SHIPMENT_WH]: "Towns / Cities"
  }
};

export default locationLbl;
